import { render, staticRenderFns } from "./CheckoutShippo.vue?vue&type=template&id=a5b46b70&scoped=true"
import script from "./CheckoutShippo.vue?vue&type=script&lang=js"
export * from "./CheckoutShippo.vue?vue&type=script&lang=js"
import style0 from "./CheckoutShippo.vue?vue&type=style&index=0&id=a5b46b70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b46b70",
  null
  
)

export default component.exports